import { Box, Link } from 'braid-design-system';
import React from 'react';

import { SBusLogo } from '../../SBusLogo/SBusLogo';
import {
  createNavLinks,
  dropdownGenericCloseDataAttr,
  navLinkIds,
} from '../utils/generalUtils';
import type { RenderVariant } from '../utils/typeUtils';

import { MenuButton } from './MenuButton';

import * as styles from './Navbar.css';

interface NavbarProps {
  variant: RenderVariant;
  baseUrl: string;
}

export const Navbar = ({ variant, baseUrl }: NavbarProps) => (
  <Box
    // background="brandAccent" affects the child icons that <MenuButton /> renders.
    // This is why this property is specified here and not in the CSS class
    background="brandAccent"
    className={styles.navbar}
  >
    <Box className={styles.homeLogoButtonContainer}>
      <Link
        id={navLinkIds.homeLogo}
        href={createNavLinks(baseUrl).home}
        title="SEEK Business - Own your own business"
        className={styles.homeLogoButton}
        data={{ [dropdownGenericCloseDataAttr]: '' }}
      >
        <SBusLogo theme="white" width="190" height="38" />
      </Link>
    </Box>

    <MenuButton variant={variant} />
  </Box>
);
